var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a-spin', {
    attrs: {
      "spinning": _vm.loading
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('router-link', {
    attrs: {
      "to": "/participants/new"
    }
  }, [_c('a-button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "primary"
    }
  }, [_c('i', {
    staticClass: "fe fe-plus-circle font-size-15",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "title": "Add participant"
    }
  }), _vm._v(" New participant ")])], 1)], 1), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.dataSource,
      "pagination": {
        pageSize: 50
      },
      "row-key": function rowKey(record) {
        return record.id;
      }
    },
    scopedSlots: _vm._u([{
      key: "lastLogin",
      fn: function fn(text) {
        return _c('span', {}, [_c('a-tag', {
          attrs: {
            "color": text === null ? 'volcano' : 'green'
          }
        }, [_vm._v(" " + _vm._s(text === null ? 'Logged out' : 'Logged in') + " ")]), _c('br'), _vm._v(" " + _vm._s(text === null ? '' : 'Logged in since:' + text) + " ")], 1);
      }
    }, {
      key: "actions",
      fn: function fn(record) {
        return _c('span', {}, [_c('a-popconfirm', {
          attrs: {
            "title": "Are you sure you want to delete this participant?",
            "ok-text": "Yes",
            "cancel-text": "No"
          },
          on: {
            "confirm": function confirm($event) {
              return _vm.deleteParticipant(record.id);
            }
          }
        }, [_c('a', [_c('i', {
          staticClass: "fe fe-x-square align-middle text-danger",
          attrs: {
            "title": "Delete participant"
          }
        })])]), _c('router-link', {
          attrs: {
            "to": "/participants/edit/".concat(record.id)
          }
        }, [_c('a', [_c('i', {
          staticClass: "fe fe-edit align-middle text-gray-6",
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "title": "Edit participant"
          }
        })])])], 1);
      }
    }])
  })], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }